export enum Nips {
  Search = 50,
}
